import { Outlet } from "react-router-dom";

import { Layout } from "@/components/layout";

export const PublicRoutesGuard = () => {
  return (
    <Layout isAuthenticated={false}>
      <Outlet />
    </Layout>
  );
};
